import { render, staticRenderFns } from "./baseLayout.vue?vue&type=template&id=db379bf0&scoped=true&"
import script from "./baseLayout.vue?vue&type=script&lang=js&"
export * from "./baseLayout.vue?vue&type=script&lang=js&"
import style0 from "./baseLayout.vue?vue&type=style&index=0&id=db379bf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db379bf0",
  null
  
)

export default component.exports